<template>
  <div class="main">
    <div class="title">
        产品出海
    </div>
    <div class="map d-none d-sm-block">
      <img src="https://holden-resource.oss-cn-shanghai.aliyuncs.com/holden/international/worldmap.png" alt="">
      <div class="people">
        <div class="box one">
          <div class="photo">
            <img src="	https://holden-resource.oss-cn-shanghai.aliyuncs.com/djs/2022/10/17/6/1665975526976.jpg" alt="">
          </div>
          <div class="value">
            <div class="name">
              Alex Tam

            </div>
            <div class="market">中国香港</div>
            <div class="text">Alex在香港拥有丰富的医疗市场研究和咨询经验。他在医疗系统、市场准入政策以及治疗方面都有丰富的经验。

            </div>
          </div>
        </div>
        <div class="box two">
          <div class="photo">
            <img src="https://holden-resource.oss-cn-shanghai.aliyuncs.com/user/2022/10/27/8/%E5%9B%BE%E7%89%872.png" alt="">
          </div>
          <div class="value">
            <div class="name">
              Baldwin Chia

            </div>
            <div class="market">新加坡</div>
            <div class="text">Baldwin不仅能为我们带来了市场研究的见解，还带来了商业见解和战略，他为大量本地和国际客户提供端到端的解决方案。

            </div>
          </div>
        </div>
        <div class="box three">
          <div class="photo">
            <img src="https://holden-resource.oss-cn-shanghai.aliyuncs.com/user/2022/10/27/8/%E5%9B%BE%E7%89%871.jpg" alt="">
          </div>
          <div class="value">
            <div class="name">
              Jeffrey Kelsch

            </div>
            <div class="market">美国</div>
            <div class="text">Jeff在医疗保健研究方面有30多年的经验，他致力于帮助客户进入西方市场，增加其在西方市场的占有率。

            </div>
          </div>
        </div>
        <div class="box four">
          <div class="photo">
            <img src="https://holden-resource.oss-cn-shanghai.aliyuncs.com/user/2023/02/22/8/%E5%9B%BE%E7%89%871.jpg" alt="">
          </div>
          <div class="value">
            <div class="name">
              Angela Wang

            </div>
            <div class="market">中国台湾</div>
            <div class="text">Angela是台湾著名的医疗器械产品营销专家，她拥有30年的经验，可以帮助客户完成他们的营销研究需求，解决营销问题。
            </div>
          </div>
        </div>
        <div class="box five">
          <div class="photo">
            <img src="https://holden-resource.oss-cn-shanghai.aliyuncs.com/user/2022/10/27/8/%E5%9B%BE%E7%89%873.jpg" alt="">
          </div>
          <div class="value">
            <div class="name">
              Gaku Sasaki
            </div>
            <div class="market">日本</div>
            <div class="text">Gaku-san是日本当地极具声望的医疗保健行业市场顾问，他拥有25年行业经验，善于向国际客户沟通日本市场的见解。
            </div>
          </div>
        </div>
        <div class="box six">
          <div class="photo">
            <img src="https://holden-resource.oss-cn-shanghai.aliyuncs.com/holden/international/scott.jpg" alt="">
          </div>
          <div class="value">
            <div class="name">
              Nicola Scott

            </div>
            <div class="market">澳大利亚</div>
            <div class="text">Nicola善于为品牌寻找机会，并利用研究结果帮助公司最大限度地提高其产品与市场需求的相关性，提高其吸引力，最终推动其在澳大利亚市场的商业成功。
            </div>
          </div>
        </div>
      </div>

    </div>

    <div class="mobilemap d-block d-sm-none">
      <!-- <img src="@/assets/img/worldmap.png" alt=""> -->
      <div class="people">
        <div class="box one">
          <div class="photo">
            <img src="	https://holden-resource.oss-cn-shanghai.aliyuncs.com/djs/2022/10/17/6/1665975526976.jpg" alt="">
          </div>
          <div class="value">
            <div class="name">
              Alex Tam

            </div>
            <div class="market">中国香港</div>
            <div class="text">Alex在香港拥有丰富的医疗市场研究和咨询经验。他在医疗系统、市场准入政策以及治疗方面都有丰富的经验。

            </div>
          </div>
        </div>
        <div class="box two">
          <div class="photo">
            <img src="https://holden-resource.oss-cn-shanghai.aliyuncs.com/user/2022/10/27/8/%E5%9B%BE%E7%89%872.png" alt="">
          </div>
          <div class="value">
            <div class="name">
              Baldwin Chia

            </div>
            <div class="market">新加坡</div>
            <div class="text">Baldwin不仅能为我们带来了市场研究的见解，还带来了商业见解和战略，他为大量本地和国际客户提供端到端的解决方案。

            </div>
          </div>
        </div>
        <div class="box three">
          <div class="photo">
            <img src="https://holden-resource.oss-cn-shanghai.aliyuncs.com/user/2022/10/27/8/%E5%9B%BE%E7%89%871.jpg" alt="">
          </div>
          <div class="value">
            <div class="name">
              Jeffrey Kelsch

            </div>
            <div class="market">美国</div>
            <div class="text">Jeff在医疗保健研究方面有30多年的经验，他致力于帮助客户进入西方市场，增加其在西方市场的占有率。

            </div>
          </div>
        </div>
        <div class="box four">
          <div class="photo">
            <img src="https://holden-resource.oss-cn-shanghai.aliyuncs.com/user/2023/02/22/8/%E5%9B%BE%E7%89%871.jpg" alt="">
          </div>
          <div class="value">
            <div class="name">
              Angela Wang

            </div>
            <div class="market">中国台湾</div>
            <div class="text">Angela是台湾著名的医疗器械产品营销专家，她拥有30年的经验，可以帮助客户完成他们的营销研究需求，解决营销问题。
            </div>
          </div>
        </div>
        <div class="box five">
          <div class="photo">
            <img src="https://holden-resource.oss-cn-shanghai.aliyuncs.com/user/2022/10/27/8/%E5%9B%BE%E7%89%873.jpg" alt="">
          </div>
          <div class="value">
            <div class="name">
              Gaku Sasaki
            </div>
            <div class="market">日本</div>
            <div class="text">Gaku-san是日本当地极具声望的医疗保健行业市场顾问，他拥有25年行业经验，善于向国际客户沟通日本市场的见解。
            </div>
          </div>
        </div>
        <div class="box six">
          <div class="photo">
            <img src="https://holden-resource.oss-cn-shanghai.aliyuncs.com/holden/international/scott.jpg" alt="">
          </div>
          <div class="value">
            <div class="name">
              Nicola Scott

            </div>
            <div class="market">澳大利亚</div>
            <div class="text">Nicola善于为品牌寻找机会，并利用研究结果帮助公司最大限度地提高其产品与市场需求的相关性，提高其吸引力，最终推动其在澳大利亚市场的商业成功。
            </div>
          </div>
        </div>
      </div>

    </div>

    <div class="end">
      浩顿全球专家 当地市场领航员，
      为您的产品出海之旅 保驾护航！

    </div>
  </div>
</template>

<script>
export default {};
</script>

<style lang="scss" scoped>
.main{
    background-color: #f8f9fa;
}
.title{
    padding: 50px 120px;
    font-weight: 700;
    font-size: 40px;
     color: #2cb1e9;
}
.map {
  padding: 250px 120px;

  position: relative;
  img {
    width: 100%;
  }
  .people {
    //  position: absolute;
    .one {
      top: 5%;
      left: 20%;
    }
    .two {
      top: 40%;
      left: 7%;
    }
    .three {
      top: 70%;
      left: 20%;
    }
    .four {
      top: 5%;
      left: 55%;
    }
    .five {
      top: 40%;
      left: 70%;
    }
    .six {
      top: 70%;
      left: 55%;
    }
    .box {
      position: absolute;
      width: 300px;
      .photo {
        position: absolute;
        right: -25%;
        top: -25%;
        width: 100px;
        height: 100px;
        border-radius: 50%;
        border: 2px solid #428cca;
        overflow: hidden;
        img {
          width: 100%;
        }
      }
      .value {
        border: 2px solid #428cca;
        width: 350px;
        height: 170px;
        padding: 10px;
        background-color: #efefef;
        .name,
        .market {
          font-weight: 700;
          font-size: 20px;
        }
      }
    }
  }
}
.end {
  padding: 0 120px;
  padding-bottom: 120px;
  text-align: center;
  font-size: 35px;
  font-weight: 700;
}
@media screen and (max-width: 576px) {
    .title{
        font-size: 80px;
    }
  .mobilemap {
    background: url("https://holden-resource.oss-cn-shanghai.aliyuncs.com/holden/international/worldmap.png") no-repeat;
    background-size: contain;
    height: 1150px;

    margin: 0px 120px;
padding: 50px 0;
    background-position: center center;

    .people {
      height: 1050px;
      padding-top: 100px;
      overflow-y: auto;
      .box {
        width: 80%;
        margin: 0 auto;
        position: relative;
        margin-bottom: 140px;
        .photo {
          position: absolute;
          right: -50px;
          top: -100px;
          width: 300px;
          height: 300px;
          border-radius: 50%;
          overflow: hidden;
          img {
            width: 100%;
          }
        }
        .value {
          background-color: rgba(255, 255, 255, 0.8);
          border: 7px solid #428cca;
          padding: 30px;
          .name,
          .market {
            font-size: 60px;
          }
          .text {
            font-size: 50px;
          }
        }
      }
    }
  }
    .people::-webkit-scrollbar {
    display: none;
  }
   .end {
    font-size: 60px;
  }
}
</style>